import { cn } from '@/utils/classnames';
import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { DrawerPortal } from './drawer-portal';
import { DrawerOverlay } from './drawer-overlay';

const DrawerContent = React.forwardRef<
  React.ElementRef<typeof DrawerPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Content> & {
    side?: 'left' | 'right' | 'bottom' | 'top';
  }
>(({ className, children, side = 'bottom', ...props }, ref) => (
  <DrawerPortal>
    <DrawerOverlay />
    <DrawerPrimitive.Content
      ref={ref}
      data-responsive-drawer=""
      className={cn(
        side === 'left' &&
        'fixed left-0 top-0 z-50 h-full w-[400px] flex flex-col rounded-r-[1.4rem] px-[4.6rem] py-[5rem] dark:bg-[#383838] bg-white',
        side === 'right' &&
        'fixed right-0 top-0 z-50 h-full lg:w-[450px] md:w-[400px] w-[80%] flex flex-col px-[4.6rem] py-[5rem] dark:bg-[#383838] bg-white',
        side === 'bottom' &&
        'fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-[1.4rem] px-[4.6rem] py-[5rem] dark:bg-[#383838] bg-white',
        side === 'top' &&
        'fixed inset-x-0 top-0 z-50 mb-24 flex h-auto flex-col rounded-b-[1.4rem] px-[4.6rem] py-[5rem] dark:bg-[#383838] bg-white',
        className,
      )}
      style={{
        boxShadow: '0px 4px 6.8px 5px #00000040',
        ...props.style,
      }}
      {...props}
    >
      {side === 'bottom' && <div className="mx-auto mt-4 h-2 w-[100px] rounded-full bg-second" />}
      {side === 'top' && <div className="mx-auto mb-4 h-2 w-[100px] rounded-full bg-second" />}
      {children}
    </DrawerPrimitive.Content>
  </DrawerPortal>
));
DrawerContent.displayName = 'DrawerContent';

export { DrawerContent };
